import { getCookie } from 'cookies-next';
import { saleTypes } from '@constants/saleTypes';

const baseUrl = process.env.NEXT_PUBLIC_BASE_URL


export const getStation = async (slug, filters, localeValue = 'en') => {
    let currencyValue = getCookie('currency')
    // let localeValue = getCookie('NEXT_LOCALE')

    // let { saleType, page } = filters
    let { saleType, project, category, room, page, minprice, maxprice, petfriendly, map, sort } = filters


    if (saleType == undefined) {
        saleType = saleTypes['en'][0].value
    }

    const url = `${baseUrl}/transports/${slug}?saleType=${saleType}&project=${project}&category=${category}&minprice=${minprice}&maxprice=${maxprice}&room=${room}&petfriendly=${petfriendly}&map=${map}&page=${page}&sort=${sort}`

    const headers = {
        'apikey': process.env.NEXT_PUBLIC_RSTBASE_API_KEY,
        'currency': currencyValue || 'thb',
        'locale': localeValue || 'en'
    }

    const response = await fetch(url, {
        headers: headers,
        cache: 'no-store'
    })

    const result = await response.json()
    // console.log(result.properties)
    return result
}